import { forwardRef } from 'react';

import { css, cx, splitResponsiveVariant } from '@/styled-system/css';

import { Slot } from '../slot';
import { dividerRecipe } from './styles/divider.styles';
import type { DividerPropsInterface } from './types/divider.types';

/**
 *
 * @since 8.38.0
 */

export const Divider = forwardRef<HTMLDivElement, DividerPropsInterface>(
  (props: DividerPropsInterface, forwardedRef) => {
    const {
      tone = 'muted',
      asChild = false,
      className,
      css: cssProp,
      orientation = 'horizontal',
      role = 'separator',
      ...rest
    } = props;

    const responsiveOrientation = splitResponsiveVariant('orientation', orientation);

    const styles = css(
      dividerRecipe.raw({
        tone,
        ...(tone === 'emphasized' ? { orientation: 'horizontal' } : responsiveOrientation),
      }),
      cssProp,
    );

    const Component = asChild ? Slot : 'div';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="Divider"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_divider', styles, className)}
        role={role}
        {...rest}
      />
    );
  },
);

Divider.displayName = 'Divider';
